import { render, staticRenderFns } from "./ocr-result.vue?vue&type=template&id=8bf90110&scoped=true&"
import script from "./ocr-result.vue?vue&type=script&lang=js&"
export * from "./ocr-result.vue?vue&type=script&lang=js&"
import style0 from "./ocr-result.vue?vue&type=style&index=0&id=8bf90110&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../kuaishou-frontend-collect/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf90110",
  null
  
)

export default component.exports